import {
  CeleryIcon,
  CrustaceanIcon,
  EggIcon,
  FishIcon,
  GlutenIcon,
  LupinIcon,
  MilkIcon,
  MolluscIcon,
  MustardIcon,
  NutsIcon,
  PeanutIcon,
  SesameIcon,
  SoyaIcon,
} from '.';
import { createElement, Fragment } from 'react';
import { AllergnItem, AllergnsProps } from './types';
import styled from 'styled-components';
import SulphiteIcon from './SulphiteIcon';

export const allergns: AllergnItem[] = [
  { name: 'fish', label: 'Pescado', icon: FishIcon },
  { name: 'celery', label: 'Apio', icon: CeleryIcon },
  { name: 'crustacean', label: 'Crustáceos', icon: CrustaceanIcon },
  { name: 'egg', label: 'Huevo', icon: EggIcon },
  { name: 'lupin', label: 'Altramuz', icon: LupinIcon },
  { name: 'milk', label: 'Lácteos', icon: MilkIcon },
  { name: 'mollusc', label: 'Moluscos', icon: MolluscIcon },
  { name: 'mustard', label: 'Mostaza', icon: MustardIcon },
  { name: 'peanut', label: 'Cacahuetes', icon: PeanutIcon },
  { name: 'soya', label: 'Soja', icon: SoyaIcon },
  { name: 'gluten', label: 'Contiene gluten', icon: GlutenIcon },
  { name: 'sesame', label: 'Granos de sésamo', icon: SesameIcon },
  { name: 'nuts', label: 'Frutos secos', icon: NutsIcon },
  {
    name: 'sulphite',
    label: 'Dióxido de azufre y sulfitos',
    icon: SulphiteIcon,
  },
];

const Icons = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
`;

export const Allergns = ({ product, size }: AllergnsProps) => {
  return (
    <Icons>
      {allergns
        .filter((allergn) => product[allergn.name])
        .map((allergn) =>
          createElement(allergn.icon, {
            width: `${size}px`,
            height: `${size}px`,
            key: allergn.name,
          })
        )}
    </Icons>
  );
};
